import { render, staticRenderFns } from "./annotations.vue?vue&type=template&id=a89195e4"
import script from "./annotations.vue?vue&type=script&lang=js"
export * from "./annotations.vue?vue&type=script&lang=js"
import style0 from "./annotations.vue?vue&type=style&index=0&id=a89195e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports